<template>
  <div class="content">
    <div class="content-item" >
        <div class="box-head">
          <div class="box-title">
            <img src="/static/img/jt.png" >
            <div>人均使用时长</div>
            <span>本周</span>
          </div>
          <div class="box-line-1"></div>
          <div class="box-line-2"></div>
          <div class="box-line-3"></div>
          <div class="box-line-4"></div>
        </div>
        <div class="box-body">
          <div class="title">人均使用时长</div>
          <div class="time">
            <span class="time-1">{{allData.time}}h</span>
            <span class="time-2">/人天</span>
          </div>
        </div>
    </div>
    <div class="content-item" >
        <div class="box-head">
          <div class="box-title">
            <img src="/static/img/jt.png" >
            <div>活跃度</div>
            <span>本周</span>
          </div>
          <div class="box-line-1"></div>
          <div class="box-line-2"></div>
          <div class="box-line-3"></div>
          <div class="box-line-4"></div>
        </div>
        <div class="box-body">
          <div class="title">
            <span style="color: #fa0;">{{allData.value}}%</span>
            <span style="margin-left: 0.625rem;">活跃度</span>
          </div>
          <div class="act"></div>
        </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        allData: {
          time : 0,
          value : 0,
        }
      }
    },
    created() {
      this.getData()
    },
    methods: {
      async getData() {
      	const { data: ret } = await axios.get("/left-one");
      	this.allData = ret;
      },
    },
  }
</script>

<style lang="less" scoped>
  .content{
    display: flex; justify-content: space-between;height: 100%;
    .content-item{
      width: 48%; display: flex;flex-direction: column;
      .box-head{
        position: relative;
        .box-title{
          display: flex; align-items: center; padding: 10px 7px; border-bottom: 1px solid #0087F9;
          div{
            color: #00EDFF;margin-left: 0.625rem;font-size: 1.25rem;
          }
          span{
            color: #0087F9;font-size: 0.875rem;align-self: end;margin-left: 0.625rem;
          }
        }
      }
      .box-body{
        flex: 1;background-color: rgba(7,65,122,0.2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title{
          background: url("/static/img/tk.png");
          background-repeat: no-repeat;
          background-size: cover;
          -webkit-background-size: cover;
          -o-background-size: cover;
          background-position: center 0;
          padding: 0.3125rem 1.25rem;
          font-weight:bold;
           margin-top: 1.25rem;
        }
        .time{
          background: url("/static/img/rjsysc@3x.png");
          background-repeat: no-repeat;
          background-size: cover;
          -webkit-background-size: cover;
          -o-background-size: cover;
          background-position: center 0;
          margin-top: 1.25rem;
          height: 120px;
          width: 120px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .time-1{
            font-weight: bold;
            color: #00EDFF;
          font-size: 1.5rem;

          }
          .time-2{
            font-size: 0.75rem;
            color: #00EDFF;
          }
        }
        .act{
          background: url("/static/img/hyd@3x.png");
          background-repeat: no-repeat;
          background-size: cover;
          -webkit-background-size: cover;
          -o-background-size: cover;
          background-position: center 0;
          margin-top: 1.25rem;
          height: 120px;
          width: 120px;
        }
      }
    }
  }


  .box-line-1{
       position: absolute;
       top: 0;
       left: 0;
       width: 10px;
       height: 10px;
       border-top: 1px solid #44C4FF;
  }
  .box-line-2{
   position: absolute;
   top: 0;
   right: 0;
   width: 10px;
   height: 10px;
   border-top: 1px solid #44C4FF;
  }
  .box-line-3{
   position: absolute;
   bottom: 0;
   left: 0;
   width: 10px;
   height: 10px;
   border-bottom: 1px solid #44C4FF;
  }
  .box-line-4{
   position: absolute;
   bottom: 0;
   right: 0;
   width: 10px;
   height: 10px;
   border-bottom: 1px solid #44C4FF;
  }


</style>
